import { useRoutes } from "react-router-dom";
import UserRoutes from "./UserRoutes";
import AuthenticationRoutes from "./AuthenticationRoutes";
import Login from "views/auth/authentication/Login";
import LandingPage from "views/landingPage/index";
import AdminRoutes from "./AdminRoutes";
import AuthGuard from "utils/route-guard/AuthGuard";

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  return useRoutes([
    {
      path: "/",
      element: <LandingPage />,
    },
    AuthenticationRoutes,
    UserRoutes,
    AdminRoutes,
  ]);
}
